import { ApiError } from '@/api/client';

/**
 * L1(e) Partner-46 — kaució-mentesség governance error → i18n-kulcs (code-first).
 *
 * A #853 BE-governance (`DepositExemptionGovernanceService`) 400-at dob
 * `{ code: 'DEPOSIT_EXEMPTION_LIST_REQUIRED' }`-del, ha EXEMPT/AUTOMATIC-ra
 * váltanál 0 listázott megbízottal (aktív képviselő / meghatalmazás). A FE a
 * `code`-ot detektálja (nyelv-/refaktor-független, robusztus) → specifikus,
 * cselekvésre-ösztönző toast; minden más hibára (ismeretlen code, régi BE,
 * hálózati hiba) a generikus mentés-hiba üzenet a fallback.
 *
 * Contract-pin (measured, #853 merged): a BE flat `{ code, message }`-t dob →
 * a `extractErrorBody` (`nested?.code ?? flat.code`) az `ApiError.code`-ba emeli.
 */
export function resolveDepositExemptionErrorKey(err: unknown): string {
  if (err instanceof ApiError && err.code === 'DEPOSIT_EXEMPTION_LIST_REQUIRED') {
    return 'partner.depositExemptionListRequired';
  }
  return 'partner.depositExemptionError';
}
